import { AuthService } from '@/main';

export default async ({ next, store, to }) => {
    // for "login as" feature
    let token = AuthService.detectToken()
    if (token) {
        AuthService.setToken(token)
        AuthService.setTokenTime()
        return next()
    }

    // for auth (via login and password)
    if (store.getters.currentUser.loggedIn) {
        await store.dispatch('getUserInfo')

        if (store.getters.currentUser.info.role.name === 'Accountant' && !['user-profile', 'invoice'].includes(to.name)) {
            return next({
                name: 'invoice',
            })
        }

        return next()
    }

    next({
        name: 'login',
        query: {
            redirectUrl: to.fullPath
        }
    })
    return false
}
